<div class="filter-bar" role="group" aria-label="Filters">
  <span *ngIf="options?.FiltersPending; else filters" data-testid="filters-pending" class="filter-bar__pending">
    Filters available after the first daily snapshot
  </span>
  <ng-template #filters>
    <!-- Licences and account owners live in Client Manager; non-clients have neither (visibleFilters). -->
    @for (def of visibleFilters; track def.field) {
      <button type="button" class="adb-filter" [attr.data-testid]="def.testId"
              [matMenuTriggerFor]="menu" #trigger="matMenuTrigger"
              [class.adb-filter--active]="selected(def.field).length > 0"
              [class.adb-filter--open]="trigger.menuOpen">
        <span class="adb-filter__label">{{ def.label }}</span>
        @if (selected(def.field).length > 0) {
          <span class="adb-filter__badge" [attr.data-testid]="def.testId + '-count'">{{ selected(def.field).length }}</span>
        }
        <i class="fa-solid fa-angle-down adb-filter__chevron" aria-hidden="true"></i>
      </button>
      <mat-menu #menu="matMenu" class="adb-filter-menu">
        @for (option of optionsFor(def); track option.value) {
          <!-- stopPropagation keeps the menu open while picking several values. -->
          <button mat-menu-item type="button" role="menuitemcheckbox" class="adb-filter-option"
                  [attr.data-testid]="def.testId + '-option'"
                  [attr.aria-checked]="isSelected(def.field, option.value)"
                  (click)="$event.stopPropagation(); toggle(def.field, option.value)">
            <span class="adb-filter-option__check" aria-hidden="true">
              @if (isSelected(def.field, option.value)) {
                <i class="fa-solid fa-check"></i>
              }
            </span>
            <span class="adb-filter-option__label">{{ option.label }}</span>
            <span class="adb-filter-option__count">{{ option.count | number }}</span>
          </button>
        }
      </mat-menu>
    }
    @if (hasFilters) {
      <button type="button" class="filter-bar__clear" data-testid="filters-clear" (click)="clear()">Clear filters</button>
    }
  </ng-template>
</div>
